'use client';

import { LinkButtonProps } from '@/_types/common';

const LinkButton = ({ href, text, bg, hoverBg, textColor, hoverTextColor }: LinkButtonProps) => (
  <a
    href={href}
    className={`rounded-lg px-4 py-2 text-xl md:w-[220px] inline-block w-full text-center ${bg} ${textColor} ease-in-out transition-all duration-300 ${hoverBg} ${hoverTextColor}`}
    rel="noopener noreferrer"
  >
    {text}
  </a>
);

export default LinkButton;
